import React from 'react';

import { CardBody, Card } from 'reactstrap';

let CustomCard = (props) => {
    return (
        <Card>
            <CardBody style={{ ...props.cardStyle }}>
                <h6 className="card-title noselect" style={{ textTransform: "none", cursor: "pointer", marginBottom: 30, ...props.style }}>
                    <p className="card-category" style={{ fontSize: 10, textAlign: "right", textTransform: "uppercase", marginBottom: 0, ...props.pStyle }}>
                        <b>{props.title}</b>
                        {props.auxiliarButtons}
                    </p>
                </h6>
                {props.children}
            </CardBody>
        </Card>
    );
}

export default CustomCard;